import get from 'lodash/get'

import * as Sentry from '@sentry/vue'

let cfg = null

export default async ({ app, store }) => {
  const fetchConfig = await fetch('resources/config.json')
    .then(data => data.json())

  const config = await fetchConfig

  const effectiveConfig = {
    get (prop, defaultValue) {
      return get(this, prop, defaultValue)
    },
    set (prop, value) {
      this[prop] = value
    },
    ...config
  }

  app.config.globalProperties.$tenantConfig = effectiveConfig
  cfg = effectiveConfig

  if (cfg.get('sentry.disabled') === true) {
    Sentry.close().then(() => {
      console.log('Sentry was shut down because it was disabled from the config.json file for this tenant')
    })
  }
}

export { cfg as config }
